import React, { useState, useEffect } from 'react';

const datasets = {
  fruits: ["\ud83c\udf4e", "\ud83c\udf4c", "\ud83c\udf47", "\ud83c\udf4d", "\ud83c\udf49", "\ud83c\udf53"],
  numbers: ["1\ufe0f\u20e3", "2\ufe0f\u20e3", "3\ufe0f\u20e3", "4\ufe0f\u20e3", "5\ufe0f\u20e3", "6\ufe0f\u20e3"],
  shapes: ["\ud83d\udd34", "\u25b2", "\ud83d\udd38", "\ud83d\udd36", "\ud83d\udd35", "\u26ab"],
  animals: ["\ud83d\udc36", "\ud83d\udc31", "\ud83d\udc30", "\ud83e\udd8a", "\ud83d\udc3c", "\ud83d\udc38"],
  weather: ["\u2600\ufe0f", "\ud83c\udf27\ufe0f", "\u2744\ufe0f", "\ud83c\udf2a\ufe0f", "\ud83c\udf08", "\u2601\ufe0f"]
};

const UnsupervisedLearningGame = () => {
  const [selected, setSelected] = useState("fruits");
  const [userGroupNames, setUserGroupNames] = useState([]);
  const [finalGroupMapping, setFinalGroupMapping] = useState({});

  useEffect(() => {
    renderStep1();
    renderStep3();
  }, [selected]);

  const updateDataset = () => {
    const val = document.getElementById('datasetSelect').value;
    setSelected(val);
  };

  const renderStep1 = () => {
    const dataContainer = document.getElementById('dataset');
    if (!dataContainer) return;
    dataContainer.innerHTML = "";
    datasets[selected].forEach(item => {
      const span = document.createElement("span");
      span.innerText = item;
      span.style = emojiStyle;
      span.draggable = true;
      span.ondragstart = drag;
      dataContainer.appendChild(span);
    });
    document.querySelectorAll('.drop-zone').forEach(zone => zone.innerHTML = "");
  };

  const renderStep2 = () => {
    const mapping = {};
    const names = Array.from(document.querySelectorAll('.group input'))
      .map(input => input.value.trim() || "Group");

    const groupedItems = [];
    const groupZones = document.querySelectorAll('.group .drop-zone');
    groupZones.forEach((zone, idx) => {
      Array.from(zone.children).forEach(span => {
        groupedItems.push(span.innerText);
        mapping[span.innerText] = names[idx];
      });
    });

    const aiGroups = document.getElementById('aiGroups');
    aiGroups.innerHTML = "";

    names.forEach((name, idx) => {
      const emojisInGroup = Array.from(groupZones[idx].children).map(el => el.innerText);
      if (emojisInGroup.length > 0) {
        const groupDiv = document.createElement('div');
        groupDiv.style = aiGroupStyle;
        groupDiv.innerHTML = `${emojisInGroup.join(" ")} <br> ${name}`;
        aiGroups.appendChild(groupDiv);
      }
    });

    const allItems = datasets[selected];
    const ungroupedItems = allItems.filter(item => !groupedItems.includes(item));
    if (ungroupedItems.length > 0) {
      ungroupedItems.forEach(item => {
        mapping[item] = "Unknown";
      });
      const unknownDiv = document.createElement('div');
      unknownDiv.style = aiGroupStyle;
      unknownDiv.innerHTML = `${ungroupedItems.join(" ")} <br> Unknown`;
      aiGroups.appendChild(unknownDiv);
    }

    setFinalGroupMapping(mapping);
    setUserGroupNames(names);
  };

  const renderStep3 = () => {
    const container = document.getElementById('testDataset');
    if (!container) return;
    container.innerHTML = "";
    datasets[selected].forEach(item => {
      const span = document.createElement("span");
      span.innerText = item;
      span.style = emojiStyle;
      span.draggable = true;
      span.ondragstart = drag;
      container.appendChild(span);
    });
  };

  const goToStep = (num) => {
    document.querySelectorAll('.step').forEach((step, idx) => {
      step.style.display = idx === num - 1 ? 'block' : 'none';
    });
    document.querySelectorAll('.dot').forEach((dot, idx) => {
      dot.classList.toggle('active', idx === num - 1);
    });
    if (num === 2) renderStep2();
    if (num === 3) renderStep3();
  };

  const allowDrop = (ev) => ev.preventDefault();

  const drag = (ev) => ev.dataTransfer.setData("text", ev.target.innerText);

  const drop = (ev) => {
    ev.preventDefault();
    const data = ev.dataTransfer.getData("text");
    const span = document.createElement("span");
    span.innerText = data;
    span.style = emojiStyle;
    span.draggable = true;
    span.ondragstart = drag;
    ev.target.closest(".group").querySelector(".drop-zone").appendChild(span);
  };

  const testDrop = (ev) => {
    ev.preventDefault();
    const data = ev.dataTransfer.getData("text");
    const box = ev.target.closest('.drop-box');
    const result = document.getElementById('testResult');
    let foundLabel = finalGroupMapping[data] || "Unknown";

    result.innerText = `AI thinks: ${foundLabel}`;
    box.classList.add('highlight');
    setTimeout(() => {
      box.classList.remove('highlight');
      result.innerText = "Drop Here! \ud83d\ude80";
    }, 2000);
  };

  const emojiStyle = "font-size: 2.5rem; padding: 20px; background-color: #FFF176; border-radius: 50%; display: inline-block; cursor: grab; box-shadow: 3px 3px 10px rgba(0,0,0,0.2); transition: transform 0.4s ease, background-color 0.3s;";

  const aiGroupStyle = "border: 5px dotted #4FC3F7; background: #E0F7FA; padding: 20px; border-radius: 25px; width: 30%; text-align: center; font-size: 1.7rem; box-shadow: 3px 3px 12px rgba(0,0,0,0.1);";

  return (
    <div style={{
  fontFamily: 'Comic Sans MS, cursive',
  background: 'linear-gradient(135deg, #FFDEE9, #B5FFFC)',
  color: '#4E342E',
  minHeight: '100vh',
  width: '100%',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundAttachment: 'fixed',
  margin: 0,
  padding: 0
}}>

    {/* <div style={{ fontFamily: 'Comic Sans MS, cursive', background: 'linear-gradient(135deg, #FFDEE9, #B5FFFC)', color: '#4E342E' }}> */}
      <h1 style={{ textAlign: 'center', color: '#FF4081', fontSize: '2.5rem', marginBottom: 10 }}>🎉 AI Unsupervised Learning: Group Similar Things 🎉</h1>
      <div className="progress" style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
        {[1, 2, 3].map(num => (
          <span key={num} className={`dot ${num === 1 ? 'active' : ''}`} onClick={() => goToStep(num)} style={{ height: 20, width: 20, margin: '0 8px', backgroundColor: num === 1 ? '#FF7043' : '#FFD54F', borderRadius: '50%', display: 'inline-block', opacity: num === 1 ? 1 : 0.5, cursor: 'pointer', transition: '0.4s', transform: num === 1 ? 'scale(1.3)' : 'none' }}></span>
        ))}
      </div>

      <div id="step1" className="step" style={{ display: 'block' }}>
        <h4 style={{ textAlign: 'center', color: '#7E57C2', marginBottom: 20 }}>Step 1: Select Dataset & Create Your Groups 📝</h4>
        <div className="dropdown22" style={{ textAlign: 'center' }}>
          <select id="datasetSelect" onChange={updateDataset} style={{ padding: 12, borderRadius: 14, fontSize: '1.1rem', border: '2px solid #FFD54F', color: '#5D4037', marginTop: 10 }}>
            <option value="fruits">🍎 🍌 🍇 🍍 🍉 🍓 Fruits</option>
            <option value="numbers">1️⃣ 2️⃣ 3️⃣ 4️⃣ 5️⃣ 6️⃣ Numbers</option>
            <option value="shapes">🔴 🔺 🔷 🔶 🔵 ⚫ Shapes</option>
            <option value="animals">🐶 🐱 🐰 🦊 🐼 🐸 Animals</option>
            <option value="weather">☀️ 🌧️ ❄️ 🌪️ 🌈 ☁️ Weather</option>
          </select>
        </div>
        <div id="dataset" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 15, margin: '20px 0' }}></div>
        <div className="groups-container" style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap' }}>
          {[0, 1, 2].map(i => (
            <div key={i} className="group" onDragOver={allowDrop} onDrop={drop} style={{ border: '4px dashed #4DD0E1', minHeight: 120, width: '30%', padding: 20, margin: 10, textAlign: 'center', borderRadius: 20,  transition: '0.3s' }}>
              <input placeholder="Type Group Name Here!" style={{ width: '85%', marginBottom: 10, textAlign: 'center', padding: 10, fontFamily: 'inherit', borderRadius: 12, backgroundColor: '#E1BEE7', border: '2px solid #BA68C8' }} />
              <div className="drop-zone"></div>
            </div>
          ))}
        </div>
        <button className="button" onClick={() => goToStep(2)} style={{ padding: '16px 35px', margin: '30px auto', display: 'block', background: 'linear-gradient(135deg, #BA68C8, #F06292)', color: 'white', fontSize: '1.2rem', borderRadius: 25, fontWeight: 'bold', cursor: 'pointer', transition: '0.3s' }}>✨ See How AI Groups Them ➡️</button>
      </div>

      <div id="step2" className="step" style={{ display: 'none' }}>
        <h2 style={{ textAlign: 'center', color: '#7E57C2', marginBottom: 20 }}>Step 2: AI’s Grouping! 🤖</h2>
        <div id="aiGroups" className="ai-groups" style={{ display: 'flex', justifyContent: 'space-around', gap: 20, flexWrap: 'wrap' }}></div>
        <button className="button" onClick={() => goToStep(3)} style={{ padding: '16px 35px', margin: '30px auto', display: 'block', background: 'linear-gradient(135deg, #BA68C8, #F06292)', color: 'white', fontSize: '1.2rem', borderRadius: 25, fontWeight: 'bold', cursor: 'pointer', transition: '0.3s' }}>🔍 Test AI ➡️</button>
      </div>

      <div id="step3" className="step" style={{ display: 'none' }}>
        <h2 style={{ textAlign: 'center', color: '#7E57C2', marginBottom: 20 }}>Step 3: Test AI’s Guess! 🎲</h2>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 50 }}>
          <div id="testDataset" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 15 }}></div>
          <div className="drop-box" onDragOver={allowDrop} onDrop={testDrop} style={{ border: '4px dashed #4DD0E1', minHeight: 120, width: '30%', padding: 20, margin: 10, textAlign: 'center', borderRadius: 20, transition: '0.3s' }}>
            <p id="testResult">Drop Here! 🚀</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnsupervisedLearningGame;
